import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';

@Component({
  selector: 'app-page-base',
  standalone: true,
  imports: [
    CommonModule,
    ToastModule,
    ConfirmDialogModule
  ],
  templateUrl: './page-base.component.html',
  styleUrls: ['./page-base.component.css']
})
export class PageBaseComponent {

}
